var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 70,
    viewBox: "0 0 57 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_939_17138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7757 32H9.10905C5.97944 32 3.44238 34.5235 3.44238 37.6364V57.3636C3.44238 60.4765 5.97944 63 9.10905 63H48.7757C51.9053 63 54.4424 60.4765 54.4424 57.3636V37.6364C54.4424 34.5235 51.9053 32 48.7757 32Z",
    stroke: "#455154",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4424 32V20.4444C15.4424 16.6135 17.0227 12.9395 19.8358 10.2307C22.6488 7.52182 26.4641 6 30.4424 6C34.4206 6 38.2359 7.52182 41.049 10.2307C43.862 12.9395 45.4424 16.6135 45.4424 20.4444V32",
    stroke: "#455154",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_939_17138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.5759,
    height: 68.5373,
    fill: "white",
    transform: "translate(0.375 0.529297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.f1ad33ecbbc0248345e205f2d70bfc0a.svg";
export { ForwardRef as ReactComponent };